<template>
  <v-row id="ports-ips" class="docScroll">
    <HeaderTemplate :data="contentHeader" />
    <SectionColumn type="full" title="Ports" :content="ports" />
    <SectionColumn type="left" title="IP addresses" :badge="'Updated'" :content="ipLeftCol" />
    <SectionColumn type="right" :content="ipRightCol" />
  </v-row>
</template>

<script>
import HeaderTemplate from "@/components/templates/HeaderTemplate";
import SectionColumn from "@/components/layout/SectionColumn";

export default {
  name: "Ports_Ip",
  components: {
    SectionColumn,
    HeaderTemplate,
  },
  data() {
    return {
      contentHeader: {
        title: "Ports and IP addresses",
        text: `<p>The following information can be used by system administrators if any changes need to be made to your servers when integrating with Payfast.</p>`,
        svg: `<svg width="29" height="29" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="20.5" r="20.5" fill="#E12E56"/><g clip-path="url(#clip0_4530_42521)"><path d="M16.0121 27.6549L18.4979 31.3433C18.7189 31.6712 19.017 31.9398 19.3661 32.1255C19.7152 32.3113 20.1046 32.4084 20.5 32.4084C20.8954 32.4084 21.2848 32.3113 21.6339 32.1255C21.983 31.9398 22.2811 31.6712 22.5021 31.3433L24.988 27.6549C26.9614 26.6472 28.5382 25.0046 29.4645 22.9917C30.3908 20.9788 30.6127 18.7127 30.0945 16.5583C29.5762 14.404 28.348 12.4867 26.6076 11.1153C24.8672 9.74392 22.7158 8.99817 20.5 8.99817C18.2842 8.99817 16.1329 9.74392 14.3924 11.1153C12.652 12.4867 11.4238 14.404 10.9055 16.5583C10.3873 18.7127 10.6092 20.9788 11.5355 22.9917C12.4618 25.0046 14.0387 26.6472 16.0121 27.6549ZM21.3601 30.5722C21.2652 30.7131 21.1371 30.8284 20.9871 30.9082C20.8372 30.988 20.6699 31.0297 20.5 31.0297C20.3301 31.0297 20.1629 30.988 20.0129 30.9082C19.8629 30.8284 19.7348 30.7131 19.6399 30.5722L18.2216 28.4701C19.7198 28.825 21.2802 28.825 22.7784 28.4701L21.3601 30.5722ZM20.5 10.3769C22.1794 10.3769 23.8211 10.8749 25.2175 11.8079C26.6138 12.7409 27.7022 14.0671 28.3449 15.6187C28.9875 17.1702 29.1557 18.8775 28.8281 20.5247C28.5004 22.1718 27.6917 23.6848 26.5042 24.8723C25.3167 26.0598 23.8037 26.8685 22.1566 27.1962C20.5094 27.5238 18.8021 27.3556 17.2506 26.713C15.699 26.0703 14.3728 24.9819 13.4398 23.5856C12.5068 22.1892 12.0088 20.5475 12.0088 18.8681C12.0115 16.6169 12.9069 14.4587 14.4988 12.8669C16.0906 11.275 18.2488 10.3796 20.5 10.3769Z" fill="white"/><path d="M18.0215 23.5498C18.2041 23.5498 18.3792 23.4773 18.5083 23.3482C18.6374 23.219 18.71 23.0439 18.71 22.8613V14.875C18.71 14.6924 18.6374 14.5173 18.5083 14.3882C18.3792 14.2591 18.2041 14.1865 18.0215 14.1865C17.8389 14.1865 17.6638 14.2591 17.5347 14.3882C17.4055 14.5173 17.333 14.6924 17.333 14.875V22.8613C17.333 23.0439 17.4055 23.219 17.5347 23.3482C17.6638 23.4773 17.8389 23.5498 18.0215 23.5498ZM20.7754 23.5498C20.958 23.5498 21.1331 23.4773 21.2622 23.3482C21.3913 23.219 21.4639 23.0439 21.4639 22.8613V19.7402H22.7261C23.4625 19.7402 24.1688 19.4477 24.6896 18.9269C25.2104 18.4062 25.5029 17.6998 25.5029 16.9634C25.5029 16.2269 25.2104 15.5206 24.6896 14.9998C24.1688 14.4791 23.4625 14.1865 22.7261 14.1865H20.7754C20.5928 14.1865 20.4177 14.2591 20.2886 14.3882C20.1594 14.5173 20.0869 14.6924 20.0869 14.875V22.8613C20.0869 23.0439 20.1594 23.219 20.2886 23.3482C20.4177 23.4773 20.5928 23.5498 20.7754 23.5498ZM21.4639 15.5635H22.7261C23.0974 15.5635 23.4534 15.711 23.716 15.9735C23.9785 16.236 24.126 16.5921 24.126 16.9634C24.126 17.3347 23.9785 17.6907 23.716 17.9533C23.4534 18.2158 23.0974 18.3633 22.7261 18.3633H21.4639V15.5635Z" fill="white"/></g><defs><clipPath id="clip0_4530_42521"><rect width="24" height="25" fill="white" transform="translate(8 9)"/></clipPath></defs></svg>`,
      },
      ports: [
        {
          doc_section_content_id: 1,
          template: "standard",
          data: {
            text: `When communicating with the notify url via the ITN, Payfast makes use of ports <strong>80, 8080, 8081</strong> and <strong>443</strong> only.`,
          },
        },
      ],
      ipLeftCol: [
        {
          doc_section_content_id: 2,
          template: "standard",
          data: {
            text: `These are the Payfast server IPs. Our information can come from any of these IPs and we recommend white-listing all of these IPs.`,
          },
        },
      ],
      ipRightCol: [
        {
          doc_section_content_id: 3,
          template: "request",
          data: {
            title: "IP Addresses",
            language: "json",
            code: `197.97.145.144/28 (197.97.145.144 - 197.97.145.159)\n41.74.179.192/27 (41.74.179.192 – 41.74.179.223)\n102.216.36.0/28 (102.216.36.0 - 102.216.36.15)\n102.216.36.128/28 (102.216.36.128 - 102.216.36.143)\n144.126.193.139`,
          },
        },
      ],
    };
  },
};
</script>

<style scoped></style>
